// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3MbR7","title":"AfterFrontImage_title__a3sF3"};